import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth uses an HttpOnly cookie set by the backend; withCredentials sends it on every request.
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const company = localStorage.getItem("stems_company");
  if (company) config.headers["X-Company-Id"] = company;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function openFile(fileId) {
  const { data } = await api.get(`/files/${fileId}/download`, { responseType: "blob", withCredentials: true });
  const url = URL.createObjectURL(data);
  window.open(url, "_blank", "noopener");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export async function uploadFile(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/files/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

let _pdfPreviewer = null;
export function registerPdfPreviewer(fn) { _pdfPreviewer = fn; }
export function isPdfPath(path) { return /\.pdf($|\?)/i.test(path) || /\/pdf($|\?)/i.test(path); }

export async function downloadExport(path, filename) {
  if (_pdfPreviewer && isPdfPath(path)) {
    _pdfPreviewer(path, filename);
    return;
  }
  const { data } = await api.get(path, { responseType: "blob", withCredentials: true });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
